import { Link } from 'react-router-dom'
import { useCookieConsent } from '@/hooks/useCookieConsent'

/**
 * Banner de consentimiento de cookies no esenciales (analítica). Se muestra
 * solo mientras el consentimiento está 'unset'. (Blindaje legal — ítem 13)
 */
export default function CookieConsentBanner() {
    const { analytics, grantAnalytics, denyAnalytics } = useCookieConsent()

    if (analytics !== 'unset') return null

    return (
        <div className="fixed bottom-0 inset-x-0 z-50 bg-gray-900 border-t border-gray-700 px-4 py-4 shadow-2xl">
            <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-3 justify-between">
                <p className="text-sm text-gray-300">
                    Usamos cookies técnicas necesarias y, con tu permiso, cookies de analítica
                    (Matomo, autoalojado) para mejorar el servicio. Consulta la{' '}
                    <Link to="/privacy" className="text-indigo-400 underline">
                        Política de Privacidad
                    </Link>
                    .
                </p>
                <div className="flex gap-2 shrink-0">
                    <button
                        onClick={denyAnalytics}
                        className="px-4 py-2 text-sm rounded-md border border-gray-600 text-gray-300 hover:bg-gray-800"
                    >
                        Rechazar
                    </button>
                    <button
                        onClick={grantAnalytics}
                        className="px-4 py-2 text-sm rounded-md bg-indigo-600 text-white hover:bg-indigo-500"
                    >
                        Aceptar analítica
                    </button>
                </div>
            </div>
        </div>
    )
}
